import { Box, Typography, Modal, Button, useTheme, useMediaQuery } from "@mui/material";
import { useSelector } from "react-redux";
import { selectUserEmail } from "../../../../redux/Slice/Authentication/AuthenticationSlice";
import { useState } from "react";
import { sendCommandControl } from "../../../../services/apis";
import { useMutation } from "@tanstack/react-query";
import { LoadingButton } from "@mui/lab";

const getModalStyle = (isSmallScreen: boolean) => ({
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: isSmallScreen ? "90vw" : 404,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  p: 4,
  maxHeight: "95vh",
  overflowY: "auto",
});

export default function TakeUnitOnlineModel({ openTakeOnlineUnitModel, setOpenTakeOnlineUnitModel, setValue, unit, setAlertState }: any) {
  const theme = useTheme();
  const userEmail = useSelector(selectUserEmail);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setValue('offline')
    setIsLoading(false);
    setOpenTakeOnlineUnitModel(false)
  };

  const bypassMutation = useMutation<number, Error, { control: string; units: string[] }>({
    mutationFn: ({ control, units }) => sendCommandControl(control, units),
    onSuccess: () => {
      console.log("Bypass command sent successfully");
      setIsLoading(false);
      handleClose();
      setAlertState({
        isAlert: true,
        severity: "info",
        title: "",
        description: "PACE AI device on the selected unit is awaiting online activation.",
        resetOpen: true,
      });
    },
    onError: (error) => {
      setIsLoading(false);
      handleClose();
      console.error("Error sending bypass command:", error);
      setAlertState({
        isAlert: true,
        severity: "error",
        title: "",
        description: "Failed to activate the PACE AI device on the selected unit. Please try again later.",
        resetOpen: true,
      });
    },
  });


  const handleSendCommand = () => {
    const serialNums: string[] = [unit?.pace_device_serial_number];
    console.log(serialNums, unit)
    setIsLoading(true);
    bypassMutation.mutate({ control: "take online", units: serialNums });
  };

  return (
    <Modal open={openTakeOnlineUnitModel} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box sx={getModalStyle(isSmallScreen)}>
        <Typography id="modal-modal-title" variant="h6">
          take unit online
        </Typography>
        <Box sx={{ marginTop: "20px" }} />
        <Typography id="modal-modal-title" variant="body1">
          This action will enable the PACE AI device for the selected unit.
        </Typography>
        <Box sx={{ marginTop: "20px" }} />
        <Typography id="modal-modal-title" variant="body1">
          Please review your selection carefully before proceeding:
        </Typography>
        <Box sx={{ marginTop: "20px" }} />
        <Typography id="modal-modal-title" variant="body1">
          {`1. ${unit?.unit_name || ""}`}
        </Typography>
        <Box sx={{ marginTop: "20px" }} />
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <Button variant="text" color="primary" size="medium" onClick={handleClose}>
            Cancel
          </Button>
          <LoadingButton
            loading={isLoading}
            variant="contained"
            onClick={handleSendCommand}
            size="medium"
          >
            take units online
          </LoadingButton>
        </Box>
      </Box>
    </Modal>
  );
}
